<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة نقطة قوة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/exchangeStrengths">نقاط القوة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة نقطة قوة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <ExchangeStrengthsForm v-if="!mainLoading" 
              cardTitle="إضافة نقطة قوة" 
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import ExchangeStrengthsForm from './form.vue';

export default {
  name: 'ExchangeStrengthsCreate',
  components: {
    ExchangeStrengthsForm,
  }, 
  data(){
    return {
      mainLoading: false,
      hasError: false,
      message: '',
      errorNumber: 0,
    };
  },
}
</script>
